import { SetLocalTimeZone, SetUTCTimeZone } from "@bbwt/utils";
import { IDateFilter, IQueryCommand } from "@features/filter";
import { IPagedData } from "@features/grid";

type DatePropertyKeys<T> = { [K in keyof T]: T[K] extends Date ? K : never }[keyof T];

export function setFiltersUTCTimeZone(command: IQueryCommand, ...filterNames: string[]) {
    const filters = command?.filters?.filter(f => filterNames.includes(f.propertyName)).map(f => <IDateFilter>f) ?? [];
    filters.forEach(f => (f.value = SetUTCTimeZone(f.value)));
}

export function setFieldsLocalTimeZone<T>(result: T, ...properties: DatePropertyKeys<T>[]) {
    properties.forEach(k => (result[k] = <any>SetLocalTimeZone(<Date>result[k])));
}

export function setPageFieldsLocalTimeZone<T>(page: IPagedData<T>, ...itemProperties: DatePropertyKeys<T>[]) {
    (page?.items ?? []).forEach(item => setFieldsLocalTimeZone(item, ...itemProperties));
}

export function setArrayFieldsLocalTimeZone<T>(arr: T[], ...itemProperties: DatePropertyKeys<T>[]) {
    (arr ?? []).forEach(item => setFieldsLocalTimeZone(item, ...itemProperties));
}
